import escape from 'lodash/escape'

/**
 * The HTML $handleErrors shows for a failed request. Server text is escaped: errors echo names and values people
 * typed, and the notification renders HTML.
 */
export function errorNotificationMessage (response) {
  const message = { data: escape(response.data.error || response.data.message) }
  const error = { data: null }

  switch (response.status) {
    case 401:
      if ((!response.data.errors || !response.data.errors.length) && response.data.error) {
        message.data = escape(response.data.error)
      }

      if (response.data.errors?.length && response.data.error) {
        message.data = `<p class="pt-1 pb-1">- ${escape(response.data.error)}</p>`
      }

      if (response.data.errors?.length) {
        for (error.data of response.data.errors) {
          message.data += `<p class="pt-1 pb-1">- ${escape(error.data)}</p>`
        }

        response.data.errors = ''
      }

      break
    case 403:
      message.data = 'You do not have enough permissions to make this request.'

      if (response.data && response.data.error) {
        message.data = escape(response.data.error)
      }

      break
    case 404:
      message.data = response?.data?.error != null ? escape(response.data.error) : 'Requested resource not found.'
      break
    case 429:
      message.data = 'Too many requests have been sent. Please wait a moment and try again later.'
      break
    case 413:
      message.data = 'File too large. Please try again with a smaller file.'
      break
    case 400:
      message.data = escape(response.data.error || response.data.message)
      break
    case 422:
      const keys = Object.keys(response.data.errors || {})

      // Without field errors, the server's own message, escaped above, is the notice
      if (keys.length) {
        message.data = ''
      }

      keys.forEach((value) => {
        message.data += keys.length > 1 ? `<p class="pt-1 pb-1">- ${escape(response.data.errors[value])}</p>` : escape(response.data.errors[value])
      })

      break
    case 500:
      message.data = 'Oops! We are having some problems right now, please try again later.'
  }

  return message.data
}
